import React, { useEffect, useState } from 'react';

export function FormatToComma(val: any) {
  return val.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
